import type { MetodevalgDto, PrognoseMetode } from '@es/shared';

export const METODENAVN: Record<PrognoseMetode, string> = {
  framskrivning: 'Framskrivning',
  rullerende: 'Rullerende snitt',
  normtall: 'Normtall',
  aktivitet: 'Aktivitet',
};

/**
 * The method's name as the grid's Metode column shows it.
 *
 * «Budsjett» for no method, because that is what the basis then IS — the same
 * statement the select makes with «Ingen metode (budsjett som basis)», short
 * enough for a table cell.
 */
export function metodenavn(valg: MetodevalgDto | null): string {
  return valg === null ? 'Budsjett' : METODENAVN[valg.metode];
}
